import React from "react";
import styles from "./modal.module.scss";

interface ModalProps {
  isOpen: boolean;
  setIsVisible: (isVisible: boolean) => void;
  children: React.ReactNode;
  overflow?: boolean;
  overflowDisableClose?: boolean;
}

const Modal: React.FC<ModalProps> = ({
  isOpen,
  children,
  setIsVisible,
  overflow = false,
  overflowDisableClose = false,
}) => {
  return isOpen ? (
    <div className={styles.modal}>
      <div className={styles.modal_content}>
        <div className={styles.overlay} onClick={() => !overflowDisableClose && setIsVisible(false)} />
        <div className={styles.modal_dialog + (overflow ? " overflow" : "")}>{children}</div>
      </div>
    </div>
  ) : null;
};

export default Modal;
